export { default as BlackFridayTitle } from './black-friday-title.webp';
export { default as BlackFridayHero } from './black-friday-hero.webp';
export { default as StarsTwinkle } from './stars-twinkle.gif';
export { default as Stars } from './stars.webp';
export { default as BFDiscount } from './cl-black-friday-25-off.webp';
export { default as BFSitewide } from './cl-black-friday-sitewide.webp';
export { default as BFSale } from './cl-black-friday-sale.webp';
